import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XN_LAZYMODULE_REGISTER_TOKEN } from './tokens/xn-lazymodule-register-token';
import { XnLazyModules } from './types/xn-lazymodule.type';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class XnLazymoduleModule {
  static forRoot(modules: XnLazyModules): ModuleWithProviders<XnLazymoduleModule> {
    return {
      ngModule: XnLazymoduleModule,
      providers: [
        {
          provide: XN_LAZYMODULE_REGISTER_TOKEN,
          useValue: modules
        }
      ]
    };
  }
}
